module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAApCAYAAADu1qNcAAABF0lEQVRIS+2WQY+CMBCFX6MLFGMihkjg//8yDkpIRExJK1WYzdSFZXUv3supYfrR6csrr4KIWgABFk/f9zgejyiKAmEYLks8toKILICvD6A7QxqA/AAyHnqq5YX4cY0Xwgvx93/kHeEd8eoIa61er9dSCDGXONROpxPyPJ9DjYhc/fF4GFGWpU7TVEZRhAl8TcIJuN1uOJ/PRiildNu2cr/fQ0rpwP8gYwyapsFutzNiHEettZb8gsE4jmGtnTM3CAIwcLlckCQJf/jpciKSWmtXYHC1Ws3QMAxuhUUnv0eD+2bwer1is9nME7uum1aY9uygOd0Z5M1WVeVa4lazLMNSJAAu3d/uEUop1HWNw+GA7Xb7do/4BhTAAqW3gONhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/open.png
// module id = iFAN
// module chunks = 1